import React, { useState } from "react";
import ContentHeader from "../Commons/Layouts/ContentHeader";
import { isAccountUser } from "../../utils/roleUtils";
import { useSelector } from "react-redux";
import AccountingSettingsForm from "./AccountingSettingsForm";
import AuthorizationError from "../Commons/Authorization/AuthorizationError";
function AccountingSettings() {
  const userType = useSelector((state) => state.auth.user.userType);
  const parentNavItem = {
    title: "Settings",
    link: "/settings",
  };

  // useStates
  const [accountList] = useState([]);
  const [isFormEdit, setIsFormEdit] = useState(true);
  const [isFormDirty, setIsFormDirty] = useState(null);
  return (
    <div>
      {isAccountUser(userType) && <AuthorizationError />}
      {!isAccountUser(userType) && (
        <>
          <div className="row mb-0">
            <div className="col-12">
              <ContentHeader
                title="Accounting Settings"
                subtitle="accounting settings"
                hideSearch="true"
                hideTotal="true"
                hideButton={true}
                hideSubtitle={true}
                parentNavItem={parentNavItem}
              />
            </div>
          </div>
          <div className="content-body-container row">
            <div className={`col-12 mb-2`}>
              <AccountingSettingsForm
                isFormEdit={isFormEdit}
                setIsFormEdit={setIsFormEdit}
                setIsFormDirty={setIsFormDirty}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default AccountingSettings;
